import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type ResourceReservationId = Branded<string, "ResourceReservationId">;
const resourceReservationIdPrefix = "resource_reservation__";
const {
    zodSchema: resourceReservationIdZodSchema,
    factory: resourceReservationIdFactory,
    assert: isResourceReservationId,
} = genericId<ResourceReservationId>(resourceReservationIdPrefix, {
    regexMatch: /(^resource_reservation_.*$)/,
});

export {
    isResourceReservationId,
    resourceReservationIdFactory,
    resourceReservationIdPrefix,
    resourceReservationIdZodSchema,
};
export type { ResourceReservationId };
